import { lazy } from "react";
export const Editor = lazy(async () => ({
    default: (await import(
    /*webpackChunkName: "react-draft-wysiwyg"*/ "react-draft-wysiwyg")).Editor,
}));
